// Currently supports paths with * and ** wildcards
export const matchRouteWithWildcards = (
  pattern: string,
  pathname: string,
): boolean => {
  const patternSegments = pattern.split("/").filter(Boolean);
  const pathSegments = pathname.split("/").filter(Boolean);

  let i = 0;
  for (; i < patternSegments.length; i++) {
    const pat = patternSegments[i];
    const seg = pathSegments[i];

    if (pat === "**") return true;

    if (pat === "*") continue;

    if (pat[0] === ":") {
      if (!seg) return false;
    } else {
      if (pat !== seg) return false;
    }
  }

  return i === pathSegments.length;
};
